import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';
import { update } from 'lodash';
import { i18n } from '../../translate/i18n';

const initialState = {
  maintenances: { count: 0, rows: [] },
  maintenance: {},
  loading: false,
  loadingInfiniteScroll: false,
  timelineMaintenances: { count: 0, rows: [] },
  timelineMaintenancesLoading: false,

  // Filters
  maintenancesFilter: {},
  filteredEquipments: [],
  filteredPlaces: [],
  filteredStatus: [],
  filteredCreatedAt: [],
  createdAt: null,
  sendToMaintenanceDate: null,
  returnFromMaintenanceDate: null,
  warranty: null,
  expiration: null,
};

const setMaintenancesFilter = (state, action) => {
  return updateObject(state, {
    maintenancesFilter: action.maintenancesFilter,
  });
};

// post Maintenances
const requestMaintenanceStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const requestMaintenanceFail = (state, action) => {
  return updateObject(state, { loading: false });
};

const postMaintenanceSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

// fetch Maintenances
const fetchMaintenancesByEquipmentStart = (state, action) => {
  return updateObject(state, { timelineMaintenancesLoading: true });
}

const fetchMaintenancesByEquipmentInfiniteScrollStart = (state, action) => {
  return updateObject(state, { loadingInfiniteScroll: true });
};

const fetchMaintenancesByEquipmentSuccess = (state, action) => {
  return updateObject(state, { timelineMaintenancesLoading: false, timelineMaintenances: action.timelineMaintenances });
}

const fetchMaintenancesByEquipmentFail = (state, action) => {
  return updateObject(state, { timelineMaintenancesLoading: false, loadingInfiniteScroll: false });
}

const fetchMaintenancesByEquipmentInfinteScrollSuccess = (state, action) => {
  const maintenanceObj = { count: action.maintenances.count, rows: [...state.timelineMaintenances.rows, ...action.maintenances.rows] }
  return updateObject(state, {
    timelineMaintenances: maintenanceObj,
    loadingInfiniteScroll: false
  });
};

// fetch Maintenance by Id
const fetchMaintenanceByIdSuccess = (state, action) => {
  return updateObject(state, {
    maintenance: action.maintenance,
    loading: false
  });
}

// update Maintenance
const updateMaintenanceSuccess = (state) => {
  return updateObject(state, { loading: false  });
}


// delete Maintenances
const deleteMaintenancesSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const clearMaintenanceInfo = (state, action) => {
  return updateObject(state, { maintenance: {} });
}

const fetchMaintenancesSuccess = (state, action) => {
  return updateObject(state, {
    maintenances: action.maintenances,
    loading: false
  });
};

// FILTERS
const filterMaintenanceEquipments = (state, action) => {
  return updateObject(state, { filteredEquipments: action.equipments });
}

const filterMaintenanceEquipmentsRemove = (state, action) => {
	let arr = [...state.filteredEquipments];
	const filteredEquipments = arr.filter(equipment => equipment.value !== action.equipment.value)
  return updateObject(state, { filteredEquipments });
}

const filterMaintenanceCreatedAt = (state, action) => {
  let createdAt = action.createdAt;
  return updateObject(state, { createdAt });
}

const filterMaintenanceCreatedAtRemove = (state, action) => {
  return updateObject(state, { createdAt: null });
}

const filterMaintenanceSendToMaintenanceDate = (state, action) => {
  let sendToMaintenanceDate = action.sendToMaintenanceDate;
  return updateObject(state, { sendToMaintenanceDate });
}

const filterMaintenanceSendToMaintenanceDateRemove = (state, action) => {
  return updateObject(state, { sendToMaintenanceDate: null });
}

const filterMaintenanceReturnFromMaintenanceDate = (state, action) => {
  let returnFromMaintenanceDate = action.returnFromMaintenanceDate;
  return updateObject(state, { returnFromMaintenanceDate });
}

const filterMaintenanceReturnFromMaintenanceDateRemove = (state, action) => {
  return updateObject(state, { returnFromMaintenanceDate: null });
}

const filterMaintenanceWarranty = (state, action) => {
  let warranty = action.warranty;
  return updateObject(state, { warranty });
}

const filterMaintenanceWarrantyRemove = (state, action) => {
  return updateObject(state, { warranty: null });
}

const filterMaintenanceExpiration = (state, action) => {
  let expiration = action.expiration;
  return updateObject(state, { expiration });
}

const filterMaintenanceExpirationRemove = (state, action) => {
  return updateObject(state, { expiration: null });
}

const filterMaintenancePlaces = (state, action) => {
  return updateObject(state, { filteredPlaces: action.places });
}

const filterMaintenancePlacesRemove = (state, action) => {
	let arr = [...state.filteredPlaces];
	const filteredPlaces = arr.filter(place => place.value !== action.place.value)
  return updateObject(state, { filteredPlaces });
}

const filterMaintenanceStatus = (state, action) => {
  return updateObject(state, { filteredStatus: action.status });
}

const filterMaintenanceStatusRemove = (state, action) => {
	let arr = [...state.filteredStatus];
	const filteredStatus = arr.filter(status => status.value !== action.status.value)
  return updateObject(state, { filteredStatus });
}

const filterMaintenanceClear = (state, action) => {
  return updateObject(state, { filteredEquipments: [], createdAt: null, sendToMaintenanceDate: null, returnFromMaintenanceDate: null, warranty: null, expiration: null, filteredPlaces: [], filteredStatus: [], /*  filteredAreas: [], filteredStatus: [], startDate: null, endDate: null */ });
}


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REQUEST_MAINTENANCE_START: return requestMaintenanceStart(state, action);
    case actionTypes.REQUEST_MAINTENANCE_FAIL: return requestMaintenanceFail(state, action);
    case actionTypes.POST_MAINTENANCE_SUCCESS: return postMaintenanceSuccess(state, action);

    case actionTypes.FETCH_MAINTENANCES_BY_EQUIPMENT_START: return fetchMaintenancesByEquipmentStart(state, action);
    case actionTypes.FETCH_MAINTENANCES_BY_EQUIPMENT_FAIL: return fetchMaintenancesByEquipmentFail(state, action);
    case actionTypes.FETCH_MAINTENANCES_BY_EQUIPMENT_SUCCESS: return fetchMaintenancesByEquipmentSuccess(state, action);
    case actionTypes.FETCH_MAINTENANCE_BY_ID_SUCCESS: return fetchMaintenanceByIdSuccess(state, action);
    case actionTypes.FETCH_MAINTENANCES_BY_EQUIPMENT_INFINITE_SCROLL_SUCCESS: return fetchMaintenancesByEquipmentInfinteScrollSuccess(state, action);
    case actionTypes.FETCH_MAINTENANCES_BY_EQUIPMENT_INFINITE_SCROLL_START: return fetchMaintenancesByEquipmentInfiniteScrollStart(state, action);

    case actionTypes.UPDATE_MAINTENANCE_SUCCESS: return updateMaintenanceSuccess(state);
    case actionTypes.DELETE_MAINTENANCE_SUCCESS: return deleteMaintenancesSuccess(state, action);
    case actionTypes.CLEAR_MAINTENANCE_INFO: return clearMaintenanceInfo(state, action);

    case actionTypes.SET_MAINTENANCES_FILTER: return setMaintenancesFilter(state, action);
    case actionTypes.FETCH_MAINTENANCES_SUCCESS: return fetchMaintenancesSuccess(state, action)
    
    case actionTypes.FILTER_MAINTENANCE_EQUIPMENTS: return filterMaintenanceEquipments(state, action);
    case actionTypes.FILTER_MAINTENANCE_EQUIPMENTS_REMOVE: return filterMaintenanceEquipmentsRemove(state, action);
    case actionTypes.FILTER_MAINTENANCE_CREATED_AT: return filterMaintenanceCreatedAt(state, action);
    case actionTypes.FILTER_MAINTENANCE_CREATED_AT_REMOVE: return filterMaintenanceCreatedAtRemove(state, action);
    case actionTypes.FILTER_MAINTENANCE_SEND_TO_MAINTENANCE_DATE: return filterMaintenanceSendToMaintenanceDate(state, action);
    case actionTypes.FILTER_MAINTENANCE_SEND_TO_MAINTENANCE_DATE_REMOVE: return filterMaintenanceSendToMaintenanceDateRemove(state, action);
    case actionTypes.FILTER_MAINTENANCE_RETURN_FROM_MAINTENANCE_DATE: return filterMaintenanceReturnFromMaintenanceDate(state, action);
    case actionTypes.FILTER_MAINTENANCE_RETURN_FROM_MAINTENANCE_DATE_REMOVE: return filterMaintenanceReturnFromMaintenanceDateRemove(state, action);
    case actionTypes.FILTER_MAINTENANCE_WARRANTY: return filterMaintenanceWarranty(state, action);
    case actionTypes.FILTER_MAINTENANCE_WARRANTY_REMOVE: return filterMaintenanceWarrantyRemove(state, action);
    case actionTypes.FILTER_MAINTENANCE_EXPIRATION: return filterMaintenanceExpiration(state, action);
    case actionTypes.FILTER_MAINTENANCE_EXPIRATION_REMOVE: return filterMaintenanceExpirationRemove(state, action);
    case actionTypes.FILTER_MAINTENANCE_CLEAR: return filterMaintenanceClear(state, action);
    case actionTypes.FILTER_MAINTENANCE_PLACES: return filterMaintenancePlaces(state, action);
    case actionTypes.FILTER_MAINTENANCE_PLACES_REMOVE: return filterMaintenancePlacesRemove(state, action);
    case actionTypes.FILTER_MAINTENANCE_STATUS: return filterMaintenanceStatus(state, action);
    case actionTypes.FILTER_MAINTENANCE_STATUS_REMOVE: return filterMaintenanceStatusRemove(state, action);
    default: return state;
  }
};

export default reducer;
